import { forwardRef } from "react";

import { flattenConversationPages, useChatConversations } from "@web-app/api";

import ChatInboxIcon from "./icons/ChatInboxIcon";

interface ChatInboxButtonProps {
  badgeClassName?: string;
  className?: string;
  iconClassName?: string;
  onClick?: () => void;
}

const ChatInboxButton = forwardRef<HTMLButtonElement, ChatInboxButtonProps>(
  function ChatInboxButton(
    { className, iconClassName, badgeClassName, onClick },
    ref,
  ) {
    const { data: conversationsData } = useChatConversations();
    const conversations = flattenConversationPages(conversationsData);
    const unreadConversationCount = conversations.filter(
      (conv) => conv.unreadCount > 0,
    ).length;

    return (
      <button ref={ref} onClick={onClick} className={className}>
        <ChatInboxIcon className={iconClassName} />
        {unreadConversationCount > 0 && (
          <span
            className={
              badgeClassName ||
              "absolute w-4 h-4 top-[3px] right-[3px] flex items-center justify-center text-xs font-semibold text-white bg-red-500 rounded-full"
            }
          >
            {unreadConversationCount > 99 ? "99+" : unreadConversationCount}
          </span>
        )}
      </button>
    );
  },
);

export default ChatInboxButton;
